import React from 'react';
import './SideBar.css'
import { Link } from 'react-router-dom';
import TableOfContents from '../TableOfContents/TableOfContents';

interface SideBarProps {
  // Define props here
}

const SideBar: React.FC<SideBarProps> = () => {
  return (
    <div className='sidebar-container'>
      <div className='categories'>
        <Link to="/totd" className="totd-link">
          Thought of the Day
        </Link>
      </div>
      <div className='table-of-contents'>
        <TableOfContents />
      </div>
    </div>
  );
};

export default SideBar;
